// export const API_URL = process.env.VUE_APP_API_URL ?? "http://172.237.148.210:8400";
export const API_URL =
  process.env.VUE_APP_API_URL ??
  process.env.VUE_APP_URL ??
  "https://api.pecsmart.cloud";
export const API_URL2 = 'https://api2.pecsmart.cloud'

export const URL_DOMAIN = 'https://suporte.pecsmart.cloud/'
export const API_PLANE_URL = "https://api.plane.so/api/v1";
export const API_INTERMEDIATE = 'https://api.plane.pecsmart.cloud'
export const API_CAMV3 = 'https://camv3api.pecsmart.cloud'
/** @deprecated Use API_URL — kept for imports that predate VUE_APP_API_URL unification. */
export const API_TEST_GAB = API_URL
export const API_PREDICTION =
  process.env.VUE_APP_PREDICTION_API_URL ??
  process.env.VUE_APP_API_URL ??
  process.env.VUE_APP_URL ??
  'https://prediction-api.pecsmart.cloud';
